<div class="media m-t-1">
  <div class="media-body">
    <div class="p-d-flex p-jc-between">
      <!-- Header title -->
      <div>
        <app-entity-follow-header
          [name]="topic.name"
          [active]="isTopicSaved"
          [ignored]="isTopicIgnored"
          [allowIgnore]="true"
          [labels]="shortcutLabels"
          [activeLabel]="topicLabel"
          [isLoading]="isAddedingOrIsRemoving"
          [showActions]="!hideFollowing"
          (toggled)="handleSaveTopic(topic)"
          (ignoreToggled)="handleIgnoreTopic($event)"
          (labelToggled)="handleTopicLabel($event)"
        ></app-entity-follow-header>
        <div class="p-mb-2" *ngIf="topic?.description">
          <span>
            {{ topic.description | slice : 0 : 250 }}
            <span *ngIf="topic.description.length > 250"
              >...
              <a
                href="javascript:void(0)"
                (click)="
                  $event.preventDefault();
                  $event.stopPropagation();
                  descriptionPanel.toggle($event)
                "
                class="read-more-link"
                >Read more</a
              >
            </span>
          </span>
          <p-overlayPanel
            #descriptionPanel
            [style]="{ 'max-width': '400px' }"
            styleClass="description-overlay"
            [baseZIndex]="100000"
            appendTo="body"
          >
            <ng-template pTemplate="content">
              <p style="margin: 0; white-space: pre-wrap">
                {{ topic.description }}
              </p>
            </ng-template>
          </p-overlayPanel>
        </div>
        <!-- Social media contacts -->
        <ul class="nav p-mb-1">
          <div class="row align-items-end">
            <li *ngIf="topic?.webSiteUrl">
              <div class="row">
                <div class="col-md-auto"></div>
                <div class="col">
                  <a [href]="topic?.webSiteUrl" [target]="'_blank'">
                    <i class="pi pi-globe font-17 m-r-3"></i>
                    Website
                  </a>
                </div>
              </div>
            </li>
            <li *ngIf="topic?.twitterUrl">
              <div class="row">
                <div class="col-md-auto"></div>
                <div class="col">
                  <a [href]="topic?.twitterUrl" [target]="'_blank'">
                    <i class="pi pi-twitter font-17 m-r-3"></i>
                    X
                  </a>
                </div>
              </div>
            </li>
            <li *ngIf="topic?.linkedInUrl">
              <div class="row">
                <div class="col-md-auto"></div>
                <div class="col">
                  <a [href]="topic?.linkedInUrl" [target]="'_blank'">
                    <i class="pi pi-linkedin font-17 m-r-3"></i>
                    LinkedIn
                  </a>
                </div>
              </div>
            </li>
            <li *ngIf="topic?.youTubeUrl">
              <div class="row">
                <div class="col-md-auto"></div>
                <div class="col">
                  <a [href]="topic?.youTubeUrl" [target]="'_blank'">
                    <i class="pi pi-youtube font-17 m-r-3"></i>
                    YouTube
                  </a>
                </div>
              </div>
            </li>
            <li *ngIf="topic?.financial">
              <div class="row">
                <div class="col-md-auto"></div>
                <div class="col">
                  <a [href]="topic?.financial" [target]="'_blank'">
                    <i class="pi pi-money-bill font-17 m-r-3"></i>
                    Financial
                  </a>
                </div>
              </div>
            </li>
          </div>
        </ul>
      </div>
      <!-- Avatar image -->
      <div *ngIf="topic?.picture">
        <img
          class="mt-4 mr-5 photo"
          [src]="topic.picture"
          onerror="this.parentElement.style.display='none'"
        />
      </div>
    </div>
    <!-- Related topics & companies -->
    <div class="related-panels">
      <section class="related-panel" *ngIf="relatedCompanies?.length">
        <h3 class="related-panel__title">Related Companies & Products</h3>
        <div class="related-panel__links">
          <a
            *ngFor="let rCompany of relatedCompanies"
            href="javascript:;"
            role="button"
            (click)="onDisplayRelatedCompanyContent(rCompany)"
            class="a-button-link"
            >{{ rCompany?.name }}</a
          >
        </div>
      </section>
      <section class="related-panel" *ngIf="relatedTopics?.length">
        <h3 class="related-panel__title">Related Topics</h3>
        <div class="related-panel__links">
          <a
            *ngFor="let rTopic of relatedTopics"
            href="javascript:;"
            role="button"
            (click)="onDisplayRelatedTopicContent(rTopic)"
            class="a-button-link"
            >{{ rTopic?.name }}</a
          >
        </div>
      </section>
    </div>
  </div>
</div>

<!-- Coverage chart section -->
<div
  class="coverage-chart-section p-grid p-m-2"
  *ngIf="!hideChartContent"
>
  <hr />
  <div
    class="coverage-chart-link p-col-12"
    (click)="goToExploreRelatedCoverage(topic)"
  >
    <label style="font-size: medium"
      >Coverage of <strong>{{ topic.name }}</strong> in the past year</label
    >
    <div id="chart-2" *ngIf="longTermChart">
      <app-long-term-chart
        class="p-p-2"
        [topic]="longTermChart"
      ></app-long-term-chart>
    </div>
    <div>
      {{ newsAuthors | number }} authors and {{ newsItems | number }} articles
    </div>
    <div class="p-text-italic" *ngIf="deltaYearPercent !== 0.000001">
      <small>
        {{
          (deltaYearPercent < 0 ? -deltaYearPercent : deltaYearPercent)
            | percent
        }}
        {{
          deltaYearPercent > 0
            ? ' more than previous year'
            : ' less than previous year'
        }}
      </small>
    </div>
  </div>
  <!--  <div class="p-col-4">-->
  <!--    <app-sov-chart [sovChartProps]="sovChartValuesA"></app-sov-chart>-->
  <!--  </div>-->
  <!--  <div class="p-col-4">-->
  <!--    <app-sov-chart [sovChartProps]="sovChartValuesB"></app-sov-chart>-->
  <!--  </div>-->
</div>
<hr />
<div class="content-heading">
  <div>
    <label style="font-size: large"
      >Recent content matching {{ topic.name }}</label
    >
    <!-- TODO This is not showing the correct label in some cases
    <span *ngIf="topic?.query" class="info-icon-wrapper">
      <i
        class="pi pi-info-circle"
        style="
          cursor: pointer;
          margin-left: 5px;
          font-size: 0.85em;
          vertical-align: super;
          color: #4a90e2;
        "
      ></i>
      <span class="custom-tooltip">{{ topic?.query }}</span>
    </span>
    -->
  </div>
  <div class="content-heading__action">
    <p-button
      class="p-button-sm coverage view-all-button"
      type="button"
      icon="pi pi-search"
      label="View all coverage of {{ topic.name }}"
      (click)="goToExploreRelatedCoverage(topic)"
    ></p-button>
  </div>
</div>

<app-content-items
  [parentName]="parentName"
  [items]="contentItems"
  [loading]="!loading"
  [pageSize]="topicContentPageSize"
  [page]="currentPage"
  [total]="topicContentTotal"
  [keywords]="searchBody?.keywords"
></app-content-items>

<div id="paginator" class="p-d-flex p-jc-between">
  <div *ngIf="topicContentTotalPages >= 2">
    <p-paginator
      #pp
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ topicContentTotal | number }} total items"
      [pageLinkSize]="3"
      [showFirstLastIcon]="false"
      (onPageChange)="getPage($event)"
      [rows]="topicContentPageSize"
      [totalRecords]="topicContentTotal"
    >
    </p-paginator>
  </div>
  <div class="report-data-action">
    <p-button
      pTooltip="Report Missing Data"
      class="p-button-sm coverage report-data-button"
      icon="pi pi-flag"
      label=""
      (click)="openReportMissingDataModal()"
    ></p-button>
  </div>
  <div id="sort">
    <app-sort-options
      (sortChangesEmiter)="sortChange($event)"
      [defaultSort]="sortSelected"
    ></app-sort-options>
  </div>
</div>
